import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { OrderSummary } from '../../../orders/order';
import RecentOrdersComponentShipment from '../../RecentOrdersComponentShipment';

const Row = ({ order }) => {
  return (
    <li key={order.id}>
      <div>
        <Link to={`/orders/view/${order.id}`}>
         {order.workOrderNumber.split('so-').pop()} - {order.name}
        </Link>
      </div>
      <div className="row">
        <div className="col-md-4 col-12">
          <div>
            {order.make} {order.model}
          </div>
          {order.poNumber && <div>PO {order.poNumber}</div>}
        </div>
        <div className="col-md-4 col-12">
          <div>{order.dealerBranchName}</div>
          <div>{order.dealerContactName}</div>
        </div>
        <div className="col-md-4 col-12">
          {order.shipments.map((shipment) => (
            <RecentOrdersComponentShipment
              key={shipment.id}
              shipment={shipment}
            />
          ))}
        </div>
      </div>
    </li>
  );
};

Row.propTypes = {
  order: PropTypes.instanceOf(OrderSummary).isRequired,
};

export default Row;
